import { callApi } from '../../core/api/services'
import { Search } from '../interfaces'

export const requestSearch = (params?: URLSearchParams) =>
  callApi<Search>(`/v2/searches?${params?.toString()}`)
